// Chuyển từ src/pages/inbox/config/inbox.ts sang đây ở pha 6: default state của goto.inboxes
// (entities/inbox/model/store.ts) cần hằng số này, và entity không được import từ pages.
export const SORT_INBOX_KEYS = {
  NEW_TO_OLD: '1',
  OLD_TO_NEW: '2',
  HIGH_TO_LOW: '3',
  LOW_TO_HIGH: '4',
};
